import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const Preloader = () => {
  const [loading, setLoading] = useState(true);
  const [counter, setCounter] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCounter((prev) => {
        if (prev >= 100) {
          clearInterval(timer);
          setTimeout(() => setLoading(false), 500);
          return 100;
        }
        return prev + 1;
      });
    }, 20);
    return () => clearInterval(timer);
  }, []);

  return (
    <AnimatePresence>
      {loading && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ y: '-100%', transition: { duration: 0.8, ease: [0.76, 0, 0.24, 1] } }}
          className="fixed inset-0 z-[100] bg-navy-900 flex flex-col items-center justify-center"
        >
          <div className="relative overflow-hidden">
            <motion.div
              initial={{ y: 100 }}
              animate={{ y: 0 }}
              className="font-serif text-4xl md:text-6xl text-white font-bold tracking-tighter mb-4"
            >
              PAGE1<span className="text-gold-500">NEWS</span>
            </motion.div>
          </div>
          
          <div className="w-64 h-[1px] bg-white/10 relative overflow-hidden mt-4">
            <motion.div 
              className="absolute top-0 left-0 h-full bg-gold-500"
              style={{ width: `${counter}%` }}
            />
          </div>
          
          <motion.span 
            className="text-gold-500 font-mono text-sm mt-4 tracking-widest"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            {counter}%
          </motion.span>

          <div className="absolute bottom-10 text-white/30 text-xs uppercase tracking-[0.4em]">
            Where Vision Meets Voice
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Preloader;